import { render } from "./MachineTranslationNotice.vue?vue&type=template&id=24e7396b&scoped=true"
import script from "./MachineTranslationNotice.vue?vue&type=script&lang=js"
export * from "./MachineTranslationNotice.vue?vue&type=script&lang=js"

import "./MachineTranslationNotice.vue?vue&type=style&index=0&id=24e7396b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e7396b"]])

export default __exports__